const sortArrByObjProp = (type, list) => list.sort((a, b) => (a[type] > b[type] ? 1 : -1));

export default sortArrByObjProp;
